<template>
  <div class="container">
    <div class="tabBar">
      <div class="tabBarItem" @click="changeActiveTab(1)">
        <span class="tabBarItem_span">截止本月</span>
        <div v-if="activeTab==1"  class="tabBarItem_line"></div>
      </div>
      <div class="tabBarItem"  @click="changeActiveTab(2)">
         <span class="tabBarItem_span">未来一年</span>
         <div v-if="activeTab==2" class="tabBarItem_line"></div>
      </div>
      <div class="tabBarItem"  @click="pushTobillHistory()">
          <div class="tabBarItem_right">
               <span class="tabBarItem_right_span">全部账单</span>
               <img class="topDiv_buttom_right_arrow" src="./../../assets/images/me/right.png" />  
          </div>      
      </div>
    </div>
     <div class="topDiv">
        
         <div class="topDiv_buttom">
           <span class="topDiv_span2">{{totalAmount.toFixed(2)}}</span>
          
         </div>
          <span class="topDiv_span1">累计待缴金额(元)</span>
     </div>

    <!-- </div> -->
     <div class="shop_list1">
         <div>
            <section class="bodyDiv">
                <div class="bodymian">
                    <div class="bodymian_item1">
                      <span class="bodymian_span_left1">待缴租金</span>
                      <span class="bodymian_span_right1">待缴物业费</span>
                    </div>
                    <div class="bodymian_item1">
                      <span class="bodymian_span_left2">{{unpaidRent==0?"-":unpaidRent.toFixed(2)}}</span>
                      <span class="bodymian_span_right2">{{unpaidProperty==0?"-":unpaidProperty.toFixed(2)}}</span>
                    </div>
                    <div class="bodymian_item1">
                      <span class="bodymian_span_left1">待缴水电费</span>
                      <span class="bodymian_span_right1">待缴其他费用</span>
                    </div>
                    <div class="bodymian_item1">
                      <span class="bodymian_span_left2">{{unpaidHydropower==0?"-":unpaidHydropower.toFixed(2)}}</span>
                      <span class="bodymian_span_right2">{{unpaidOther==0?"-":unpaidOther.toFixed(2)}}</span>
                    </div>
                </div>
            </section>
             <div v-if="hasData" >
                <section  class="list_cell" v-for="(item,index) in dataList" :key="index"  >
                    <div class="list_item_top">
                        <!-- merchantName -->
                        <div class="list_item_top_left">
                            <div v-if="settleStatus!=1" class="list_item_top_left_div">
                                <div @click="changeSelect(index)" v-if="item.isSelect=='0'" class="unselect_div" ></div>
                                <img @click="changeSelect(index)" v-else class="select_pic" :src='require(`./../../assets/images/icon_check_${common.theme}.png`)' />
                            </div>
                            <img v-if="item.feeCodeName.indexOf('联合办公')!==-1" class="list_item_top_icon"
                                      src="../../assets/images/icon_bill_other.png" />
                            <img v-else-if="item.feeCodeName.indexOf('电费')!==-1" class="list_item_top_icon"
                                    src="../../assets/images/icon_bill_electric.png" />
                            <img v-else-if="item.feeCodeName.indexOf('租金')!==-1" class="list_item_top_icon"
                                    src="../../assets/images/icon_bill_rent.png" />
                            <img v-else-if="item.feeCodeName.indexOf('水费')!==-1" class="list_item_top_icon"
                                    src="../../assets/images/icon_bill_water.png" />
                            <img v-else-if="item.feeCodeName.indexOf('物业')!==-1" class="list_item_top_icon"
                                    src="../../assets/images/icon_bill_property.png" />
                            <img v-else class="list_item_top_icon"
                                    src="../../assets/images/icon_bill_other.png" />
                            <span class="list_item_top_span1">{{item.feeCodeName}}</span>
                            <span v-if="item.freezeStatus==2" class="redSpan" >{{'冻结'}}</span>

                        </div>
                        <div class="list_item_top_right" @click="pushToDetail(item)">
                          <!-- actualAmount -->
                            <span class="list_item_top_span2">¥ {{item.needPayAmount.toFixed(2)}}</span>
                            <img class="list_item_top_right_arrow" src="./../../assets/images/me/right.png" />
                        </div>
                    </div>
                    <div class="list_item_body" @click="pushToDetail(item)">
                        <div class="list_item_body_item1">
                            <span class="list_item_body_span1">租客名称</span>
                            <!-- contractNo -->
                            <span class="list_item_body_span12">{{item.payerName}}</span>
                        </div>
                        <div class="list_item_body_item1">
                            <span class="list_item_body_span1">所属项目</span>
                            <!-- project -->
                            <span class="list_item_body_span2">{{item.subProjectName}}</span>
                            <span class="list_item_body_span1">账单编号</span>
                            <!-- arrearsNo -->
                            <span class="list_item_body_span2">{{item.billCode}}</span>
                        </div>
                        <div class="list_item_body_item1">
                            <span class="list_item_body_span1">最迟缴款</span>
                            <!-- contractNo -->
                            <span class="list_item_body_span12">{{item.endDate}}</span>
                        </div>

                    </div>
                    <img v-if="item.waiverAmount && item.waiverAmount>0"  class="list_item_top_icon1" src="../../assets/images/img_overdue.png" />
                </section>
             </div>
            <div class="nodataView" v-if="dataList.length==0 &&isLoaded">
                <img class="nodataImage" src="../../assets/images/icon_blank_praise.png"/>
                <span class="nodataspan1">账单已全部缴清</span>
                <span class="nodataspan">好棒！点个赞</span>
            </div>

        </div>
     </div>


      <!-- <div class="foot" v-if="hasData && settleStatus==1" >
          <div class="bill_foot_button button" @click="showInsert()">
              <span class="foot_span4 btn_default">支付账单</span>
          </div>
      </div> -->

      <!-- <div class="foot" v-if="hasData && settleStatus!=1">
            <div class="bill_foot_left">
                <div class="bill_foot_left1">
                   <div class="unselect_div" v-if="!slelctAllFlag" @click="selelctAllAction" ></div>
                   <img v-else class="select_pic" :src='require(`./../../assets/images/icon_check_${common.theme}.png`)' @click="selelctAllAction"/>
                   <span class="bill_foot_left1_span">全选</span>
                </div>
                <div class="bill_foot_left2">
                  <span class="foot_span1">合计：</span>
                  <span class="foot_span2">¥{{allPayAmount.toFixed(2)}}</span>
                </div>
            </div>
             <div v-if="isChouse" class="foot_right button" @click="insertAccountOrder()">
                <span class="foot_span3 btn_default">立即支付</span>
            </div>
             <div v-else class="foot_right button" >
                <span class="foot_span5">立即支付</span>
            </div>
      </div> -->

  </div>
</template>
<script>
import { getOnlineBillingByParam,insertAccountOrder } from "../../utils/api";
import util from "../../utils/util";
import ping from '../../utils/pingpay.js'
import Scroll from "../../components/scroll";
import storage from '../../utils/storage'
import { mapState } from 'vuex';
// import NoMessage from "../../components/nomessage";

export default {
  name: "bill",
  components: {
     Scroll,
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  filters: {
      formatTime(val){

         if(!val ||val ==undefined ||val==null){
              return ""
          }
        return util.formatTime(new Date(val),6);
      },
      formatYM(val){
         if(!val ||val ==undefined ||val==null){
              return ""
          }
        return util.formatTime(new Date(val),66);
      }
  },
  data() {
    return {
      activeTab: 1,
      settleStatus:1,
      allPayAmount:0, //总支付费用
      slelctAllFlag:false,
      changeIndex:-1,
      dataList: [],
      allLoaded:true,
      isLoaded:false,
      hasData:false,
      billTotal: 0,
      unpaidHydropower: 0, //待缴水电费
      unpaidOther: 0,    //待缴其他费用
      unpaidProperty: 0, //待缴物业费
      totalAmount: 0, //累计待缴金额
      unpaidRent: 0, //待缴租金
      normalBillList: [],   //待缴账单
      arrearsList: [],    //欠费账单
      orderNo:'', //订单编号
      canPay:true,
      isChouse:false,
      receiptId:[],
    }
  },
  created() {
   // this.getNoticeListAction();
  },
  activated () {
     this.getOnlineBillingByParam();
  },

  methods: {
      showInsert(){
        this.settleStatus =2;
      },
      changeActiveTab(type){
        if(this.activeTab!=type){
          this.activeTab = type;
          this.getOnlineBillingByParam();
        }
      },
      //充值按钮
      // canInsertAccount(){
      //    var idList =[];
      //    for(var i=0;i<this.dataList.length;i++){
      //       var iitem= this.dataList[i];
      //       if(iitem.isSelect=='1'){
      //         idList.push(iitem.id)

      //       }
      //     }
      //     if(idList.length==0){
      //       return false;
      //     }
      //   return true;
      // },
      //生成订单
     insertAccountOrder(){
          if(this.orderNo){
            this.payAction();
            return;
          }
          var item='';
          var idList =[];
          for(var i=0;i<this.dataList.length;i++){
            var iitem= this.dataList[i];
            if(iitem.isSelect=='1'){
              if(!item){
                item =  iitem;
              }
              idList.push(iitem.id)

            }
          }
          if(idList.length==0){
            util.showToast("请先选择需要支付的账单")
            return;
          }
          this.receiptId =item.receiptId;
          let params = {
              id:idList.join(','),
              "billCode": item.billCode,
              "realAmount":item.realAmount,
              "needPayAmount": this.allPayAmount,
              "planAmount": item.planAmount,
              "waiverAmount": 0,
              "contCode": item.contCode,
              "marketId": String(item.subProjectId) ,
              "phone": this.common.userInfo.account,
              "createUser": this.common.userId,
              'createName': this.common.userTenantInfo.userName,
              'companyName': item.payerName,
              'accountCycle': item.billEndDate,
          }


        insertAccountOrder(params).then(ret => {
           if (!ret.res) {
            return;
           }
          if (ret.res.code === 10000 && ret.body) {
            this.orderNo = ret.body.orderNo
            this.payAction();
          //  self.showPayComponents = true
          } else {
          // toast.showMessage(ret.res.msg);
            util.showToast(ret.res.msg)
          }
        })

     },

     payAction(){
        if(!this.canPay){return;}
        this.canPay = false;
        let params = {
          orderNo: this.orderNo,
          repairNo: '', // "报修单号",
          bussinessType:"3",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
          // feeCode:this.feeCode,
          // feeName:this.feeCodeName,
          receiptId:this.receiptId,
          // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
          channel: 'wx_pub' // 渠道名
        };
        ping(params, '', res => {
            console.log(res);
            setTimeout(() => {
              this.canPay = true;
              //this.$router.go(-1);
              this.settleStatus=1;
              this.slelctAllFlag=false;
              this.getOnlineBillingByParam();
            }, 1000);

          }, () => {
            setTimeout(() => {
              this.canPay = true;
             // this.$router.go(-1);
              this.settleStatus=1;
              this.slelctAllFlag=false;
              this.getOnlineBillingByParam();
            }, 1000);
          }, () => {
            setTimeout(() => {
              this.canPay = true;
              this.settleStatus=1;
              this.slelctAllFlag=false;
              this.getOnlineBillingByParam();
             // this.$router.go(-1);
            }, 1000);
          }
        );
        setTimeout(()=>{this.canPay = true},1000)
     },
      changeSelect(index){
          // var listStr = JSON.stringify(this.dataList)
          // var list = JSON.parse(listStr)
          var item = this.dataList[index];
          //  list[index];
          this.orderNo='';
          //this.normalBillList[index];
          if(item.isSelect=='0'){
             item.isSelect ='1';
          }else{
            item.isSelect ='0';
          }


          this.slelctAllFlag =false;
          //console.log(" " + JSON.stringify(list) )
         // this.dataList=list; //交换刷新界面
          this.changeIndex =index;
          var allFlag =true;
          var payNum =0;
          var choose=false;
          for(var i=0;i<this.dataList.length;i++){
             var iitem = this.dataList[i];
             if(iitem.isSelect =='0'){
               allFlag =false;
             }else{
               console.log(iitem.needPayAmount);
               payNum =payNum+iitem.needPayAmount;
               choose =true;
             }
          }
          this.isChouse =choose;

          this.allPayAmount = payNum;
          this.slelctAllFlag =allFlag
      },

      selelctAllAction(){
           var payNum =0;
           this.orderNo='';
           if(this.slelctAllFlag==false){
              for(var i=0;i<this.dataList.length;i++){
                    var item = this.dataList[i];
                    item.isSelect ='1';
                    console.log(item.needPayAmount);
                    payNum =payNum+item.needPayAmount;
              }
              this.allPayAmount = payNum;
              this.slelctAllFlag =true;
              this.isChouse =true;
           }else{
             for(var i=0;i<this.dataList.length;i++){
                    var item = this.dataList[i];
                    item.isSelect ='0';
              }
              this.allPayAmount = 0;
              this.slelctAllFlag =false;
              this.isChouse =false;
           }
      },
    //上拉
     loadup(){
      //  console.log("in loadup");
      //  if(this.isLoding){
      //    return;
      //  }
      //  if(this.allLoaded){
      //    return;
      //  }
      //  this.pageNo=this.pageNo+1;
      //  this.getNoticeListAction();
     },

     //下拉刷新
     loadData(){
      //  if(this.isLoding){
      //    return;
      //  }
      //  this.pageNo=1;
      //  this.allLoaded =false;
      //  this.getNoticeListAction();
     },

     getOnlineBillingByParam(){
        //  var currentDate = new Date();
        //  var endYear = currentDate.getFullYear();
         let params = {
              'userId': this.common.userId
          }
          if(this.activeTab==1){ //  加一个dateType  1截至本月 2未来一年
            params.dateType = 1;
          }else{
            params.dateType = 2;
          }
          this.allPayAmount =0;
          this.isChouse=false;
          getOnlineBillingByParam(params).then(res => {
            this.isLoding=false;
            this.isLoaded =true;
        // this.isFrist =false;
            if (res.res.code === 10000 && res.body) {
               console.log(res);
                this.totalAmount = parseFloat(res.body.totalAmount) ;
                this.unpaidRent =  parseFloat(res.body.unpaidRent);
                this.unpaidProperty =  parseFloat(res.body.unpaidProperty);
                this.unpaidHydropower =  parseFloat(res.body.unpaidHydropower);
                this.unpaidOther =  parseFloat(res.body.unpaidOther);

                this.arrearsList = res.body.arrears;
                this.normalBillList = res.body.normalBill;
                for(var i=0;i<this.normalBillList.length;i++){
                    var item = this.normalBillList[i];
                    item.isSelect = '0';
                    if(!item.feeCodeName ||item.feeCodeName==undefined){
                       item.feeCodeName ='其他';
                    }
                }

                this.dataList=[];
                if(this.arrearsList&& this.arrearsList.length>0){
                   this.dataList= this.dataList.concat(this.arrearsList);
                }
                if(this.normalBillList&& this.normalBillList.length>0){
                   this.dataList= this.dataList.concat(this.normalBillList);
                }
                if(this.dataList.length>0){
                  this.hasData =true;
                }else{
                  this.hasData =false;
                }
            }else{
                this.normalBillList = [];   //待缴账单
                this.arrearsList = [];   //欠费账单
                this.dataList=[];
                this.hasData =false;
                util.showToast(res.res.msg)
                //toast.showMessage(res.res.msg);
            }

         });
     } ,

     pushToDetail(item){
        //  item.arrearsNo,
        //  item.projectId,
        //"contCode":"HT-201909-000031","subProjectName":"鲁能国际","endDate":"2019.08.17",
        //"settleStatus":2,"billCode":"AC-201909-000642","feeCodeName":"电费",
      // "realAmount":0.0,"checkStatus":false,"reqStatus":true,
      //"feeCode":"602","subProjectId":2,"payerName":"上海彬彬科技有限公司",
      //"needPayAmount":1000.0,"id":3612,"startDate":"2019.09.17","planAmount":1000.0
         if(!item.waiverAmount){
           item.waiverAmount=0;
         }
         if(!item.needPayAmount){
           item.needPayAmount=0;
         }
         if(!item.planAmount){
           item.planAmount=0;
         }
        if(!item.realAmount){
           item.realAmount=0;
         }

        // var param = "contCode="+item.contCode+"&subProjectName="+item.subProjectName+"&endDate="+item.endDate+
        // "&settleStatus="+item.settleStatus+"&billCode="+item.billCode+'&feeCodeName='+item.feeCodeName+
        // "&realAmount="+item.realAmount+"&checkStatus="+item.checkStatus+"&reqStatus="+item.reqStatus+
        // "&feeCode="+item.feeCode+"&subProjectId="+item.subProjectId+"&payerName="+item.payerName+
        // "&needPayAmount="+item.needPayAmount+"&id="+item.id+"&startDate="+item.billStartDate+"&billEndDate="+item.billEndDate+
        // "&planAmount="+item.planAmount+"&waiverAmount="+item.waiverAmount+"&receiptId="+item.receiptId;
          storage.setS('billDetailString', JSON.stringify(item))
        setTimeout(() => {
            var url ='/billDetail';
            //  var url ='/billDetail?' +param;
            this.$router.push(url);
        }, 100)
     },
     pushTobillHistory(){
        var url ='/billHistory';
        this.$router.push(url);
     },

  }

}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  background-color: #EDEDED;
  .flex(column);
  .shop_list1 {
    flex: 1;
     height: 500px;
  }
}
.tabBar{
  width: 100%;
  height: 80px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  
}
.tabBarItem{
  width: 33.3%;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tabBarItem_span{
  font-size: 36px;
  margin-top: 9px;
  font-weight:bold;
  color:rgba(51,51,51,1);
  line-height: 57px;
}
.tabBarItem_line{
  margin-top: 6px;
  width: 80%;
  height: 4px;
  display: flex;
  background-color: #000000;
}

.tabBarItem_right{
  width: 100%;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.tabBarItem_right_span{
  font-size: 36px;
   
  color:rgba(102,102,102,1);
  line-height: 60px;
}



.topDiv{
  width: 100%;
  background-color: #EDEDED;
  flex-direction: column;
  display: flex;
}
.topDiv_span1{
  margin-top: 16px;
  margin-left: 28px;
  height:34px;
  font-size:24px;
  color:rgba(102,102,102,1);
  line-height:34px;
}

.topDiv_buttom{
  width: 100%;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 16px;

}

.topDiv_span2{
  margin-top: 14px;
  margin-left: 28px;
  height:72px;
  font-size:60px;
  font-weight:bold;
  color:rgba(51,51,51,1);
  line-height:72px;

}
.topDiv_buttom_right{
  flex-direction: row;
  justify-content:flex-end;
  align-items: center;
  margin-right: 28px;

}

.topDiv_span3{
  height:40px;
  font-size:28px;
  color:rgba(102,102,102,1);
  line-height:40px;
}

.topDiv_buttom_right_arrow{
  margin-left: 4px;
  width: 32px;
  height: 32px;
  margin-bottom: 4px;
}

.bodyDiv{
  display: flex;
  background-color: #EDEDED;
  width: 100%;
  height: 352px;
  flex-direction: row;
  align-items: center;
}
.bodymian{
  display: flex;
  margin-top: 5px;
  margin-left: 3%;
  width:94%;
  // margin-right: 20px;
  height:284px;
  background:rgba(23,64,218,1);
  box-shadow:0px 8px 16px 0px rgba(194,201,227,1);
  border-radius:16px;
  flex-direction: column;
}

.bodymian_item1{
  //width:710px;
  flex-direction: row;
  display: flex;
}
.bodymian_span_left1{
  margin-top: 36px;
  margin-left: 40px;
  width: 340px;
  display: flex;
  height:34px;
  font-size:24px;
  color:rgba(255,255,255,0.7);
  line-height:34px;

}

.bodymian_span_left2{
  margin-top: 8px;
  margin-left: 40px;
  width: 340px;
  display: flex;
  height:44px;
  font-size:32px;
  font-weight:bold;
  color:rgba(255,255,255,1);
  line-height:44px;

}

.bodymian_span_right1{
  margin-top: 36px;
  margin-left: 14px;
  width: 340px;
  display: flex;
  height:34px;
  font-size:24px;
  font-weight:400;
  color:rgba(255,255,255,0.7);
  line-height:34px;

}
.bodymian_span_right2{
  margin-top: 8px;
  margin-left: 14px;
  width: 340px;
  display: flex;
  height:44px;
  font-size:32px;
  font-weight:bold;
  color:rgba(255,255,255,1);
  line-height:44px;
}

//listitem

.list_cell{
  width: 100%;
  // height: 442px;
  // display: flex;
  background-color: #ffffff;
  flex-direction: column;
  margin-bottom: 14px;
   position: relative;
}
.list_item_top{
  width: 100%;
  height: 88px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 1px;
  border-bottom-color: #EAEAEA;
  border-bottom-style: solid;
}
.list_item_top_left{
  flex-direction: row;
  justify-content:flex-start;
  align-items: center;
  margin-left: 28px;
  display: flex;

}
.list_item_top_left_div{
    margin-right: 20px;
    flex-direction: row;
    justify-content:flex-start;
    align-items: center;
}

.list_item_top_icon{
    display: flex;
    width: 44px;
    height: 44px;

}
.list_item_top_icon1{
    position: absolute;
    top: 0;
    right:218px ;
    width: 100px;
    height: 78px;
}
.list_item_top_span1{
  margin-left: 12px;
  height:40px;
  font-size:28px;
  color:rgba(51,51,51,1);
  line-height:40px;
}
.redSpan{
  margin-left: 20px;
  height:48px;
  font-size:28px;
  line-height:48px;
  padding-left: 10px;
  padding-right: 10px;

  background: #FFF2F0;
  color: red;
}
.list_item_top_right{
  flex-direction: row;
  justify-content:flex-end;
  align-items: center;
  margin-right: 28px;

}
.list_item_top_span2{
  height:40px;
  font-size:28px;
  font-weight:bold;
  color:rgba(51,51,51,1);
  line-height:40px;

}

.list_item_top_right_arrow{
  margin-left: 4px;
  width: 32px;
  height: 32px;
  margin-bottom: 6px;
}

.list_item_body{
  width: 100%;
  // display: flex;
  flex-direction: column;
  border-bottom-width: 1px;
  border-bottom-color: #EAEAEA;
  border-bottom-style: solid;
  padding-bottom: 28px;
  // background-color: greenyellow;
}

.list_item_body_item1{
   margin-top: 28px;
   margin-left: 28px;
   justify-content:flex-start;
   align-items: flex-start;
   display: flex;
   width: 694px;
   flex-direction:row;
  //  background-color: red;

}

.list_item_body_span1{
  width: 124px;
  height:34px;
  font-size:24px;
  color:rgba(153,153,153,1);
  line-height:34px;
  display: flex
}
.list_item_body_span2{
  width: 223px;
  word-break: break-all;
  font-size:24px;
  color:rgba(51,51,51,1);
  line-height:34px;
  // background-color: aqua;
  // display: flex
}

.list_item_body_span12{
  width: 570px;
  height:34px;
  font-size:24px;
  color:rgba(51,51,51,1);
  line-height:34px;
  display: flex
}
.list_item_bottom{
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 28px;

}

.nodataView{
    width: 100%;
    height: 600px;
    // flex: 1;
    flex-direction: column;
    // justify-content: center;
    // align-items: center;
    display: flex;

  }
  .nodataImage{
    margin-top: 120px;
    margin-left: 325px;
    width: 100px;
    height: 100px;
    display: block;
  }

  .nodataspan1{
    margin-top: 28px;
    height:50px;
    font-size:36px;
    width: 100%;
    text-align: center;
    color:rgba(51,51,51,1);
    line-height:50px;
    display: block;
  }
  .nodataspan{
    display: block;
    margin-top: 20px;
    width: 100%;
    text-align: center;
    height:40px;
    font-size:28px;
    color:rgba(153,153,153,1);
    line-height:40px;
  }


  //foot
.foot{
    width: 100%;
    height: 108px;
    background-color: #ffffff;
    flex-direction: row;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.bill_foot_button{
  flex-direction: row;
  margin-left: 28px;
  // display: flex;
  // width:694px;
  // height:88px;
  // border-radius:8px;
}

.bill_foot_left{
    margin-left: 28px;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    width: 502px;
    display: flex;
}
.bill_foot_left1{
   justify-content:flex-start;
   align-items: center;
   flex-direction: row;
   display: flex;
}
.unselect_div{
    width: 32px;
    height: 32px;
    border-radius:16px;
    border-color: #DADADA;
    border-style: solid;
    border-width: 1px;
}
.select_pic{
   width: 32px;
   height: 32px;
}
.bill_foot_left1_span{
  font-size:28px;
  margin-left: 20px;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:40px;
}

.bill_foot_left2{
  align-items: center;
  flex-direction: row;
  margin-right: 28px;
}
.foot_span1{
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.foot_span2{
    height:44px;
    font-size:32px;
    font-weight:500;
    color:rgba(252,63,86,1);
    line-height:44px;
}

.foot_right{
     margin-right: 28px;
     justify-content: flex-end;
     align-items: center;
}
.foot_span3{

    width:192px;
    height:68px;
    display: block;
    text-align: center;
    background:rgba(23,64,218,1);
    border-radius:4px;
    font-size:28px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height: 68px;

}

.foot_span4{

    width:694px;
    height:68px;
    display: block;
    text-align: center;
    background:rgba(23,64,218,1);
    border-radius:4px;
    font-size:28px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height: 68px;

}

.foot_span5{

    width:192px;
    height:68px;
    display: block;
    text-align: center;
    background:#c9c9c9;
    border-radius:4px;
    font-size:28px;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height: 68px;

}

</style>